
//----------------------------------------------------------
// Generated file, DO NOT EDIT.
// To regenerate this file, run "GenerateConstants.cmd" .

// Generated data for the following assemblies:
// Microsoft.VisualStudio.Services.MemberEntitlementManagement.WebApi
// Microsoft.VisualStudio.Services.WebApi
// Microsoft.VisualStudio.Services.Common
//----------------------------------------------------------


export module DirectoryEntityType {
    /**
    * This concrete type implies that the directory entity represents a user.
    */
    export const User = "User";
    /**
    * This concrete type implies that the directory entity represents a group.
    */
    export const Group = "Group";
    /**
    * This concrete type implies that the directory entity represents a service principal.
    */
    export const ServicePrincipal = "ServicePrincipal";
}

export module DirectoryName {
    /**
    * This is a concrete directory.
    */
    export const VisualStudioDirectory = "vsd";
    /**
    * This is a concrete directory.
    */
    export const AzureActiveDirectory = "aad";
    /**
    * This is a concrete directory.
    */
    export const MicrosoftAccount = "msa";
    /**
    * This is a concrete directory.
    */
    export const GitHub = "ghb";
}

export module IdentityConstants {
    export const MsaDomain = "Windows Live ID";
    export const GitHubDomain = "github.com";
}

export module OperationTarget {
    export const AccessLevel = "accessLevel";
    export const ProjectEntitlements = "projectEntitlements";
    export const Extensions = "extensions";
    export const TeamRefs = "teamRefs";
    export const ReinstateAssets = "reinstateAssets";
}

export module OriginName {
    export const AzureActiveDirectory = "aad";
    export const MicrosoftAccount = "msa";
    export const VisualStudioTeamServices = "vsts";
    export const GitHubDirectory = "ghb";
}

export module SubjectKind {
    export const Group = "group";
    export const User = "user";
    export const ServicePrincipal = "servicePrincipal";
}

export module SubjectType {
    export const AadUser = "aad";
    export const MsaUser = "msa";
    export const AadGroup = "aadgp";
    export const AadServicePrincipal = "aadsp";
    export const VstsGroup = "vssgp";
    export const BindPendingUser = "bnd";
}

export module UserEntitlementFilterNames {
    export const LicenseId = "licenseId";
    export const LicenseStatus = "licenseStatus";
    export const AssignmentSource = "assignmentSource";
    export const UserType = "userType";
    export const Name = "name";
}

export module UserEntitlementPropertyNames {
    export const Projects = "projects";
    export const GroupRules = "grouprules";
}

export module UserEntitlementSortColumns {
    export const DisplayName = "DisplayName";
    export const Name = "name";
    export const DateAdded = "dateAdded";
    export const DateCreated = "dateCreated";
    export const LastAccessDate = "LastAccessDate";
    export const LastAccessed = "lastAccessed";
}

export module UserMetaType {
    export const Member = "member";
    export const Guest = "guest";
    export const Application = "application";
    export const ManagedIdentity = "managedIdentity";
}

